const fromdataedit = [{
		inputdata: '',
		title: '公司编码',
		fontSize: '14px',
		color: '#999999',
		placeholder: '保存后系统生成',
		types: 'text',
		inputtype: 'input',
		width: '200px',
		disabled: true,
		lablewith: '90px'
	},
	{
		inputdata: '',
		title: '公司名称',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '200px'
	},
	{
		inputdata: '',
		title: '父级编码',
		fontSize: '14px',
		color: '#333333',
		placeholder: '全部',
		types: '',
		inputtype: 'select',
		width: '220px',
		options: []
	},
	{
		inputdata: true,
		title: '允许自动入库',
		fontSize: '14px',
		color: '#333333',
		placeholder: '',
		types: '',
		inputtype: 'checkboxs',
		checkboxdata: [{
			label: "1",
			value: ""
		}],
		width: '',
		lablewith: '90px'
	},
	{
		inputdata: '',
		title: '备注',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '515px',
		lablewith: '195px'
	},
	{
		inputdata: '',
		title: '是否启用',
		fontSize: '14px',
		color: '#333333',
		placeholder: '',
		types: 'text',
		inputtype: 'radio',
		width: "210px",
		radiotitle1: "是",
		radiotitle2: "否",
		lablewith: '90px'
	},
	{
		inputdata: '',
		title: '企业负责人',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '200px',
	},
	{
		inputdata: '',
		title: '经营地址',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '210px',
	},
	{
		inputdata: '',
		title: '法人代表',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '200px',
		lablewith: '90px'
	},
	{
		inputdata: '',
		title: '仓库地址',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '515px',
	},
	{
		inputdata: '',
		title: '经营许可证',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '200px',
		lablewith: '90px'
	},
	{
		inputdata: "",
		title: "起始时间",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "dates",
		width: "200px",
		//   lablewith: '95px'
		widths: "215px"
	},
	{
		inputdata: "",
		title: "有效期至",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "dates",
		width: "200px",
		lablewith: '95px',
		widths: "215px"
	},
	{
		inputdata: '',
		title: '备案凭证编号',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '200px',
		lablewith: '90px'
	},
	{
		inputdata: "",
		title: "起始时间",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "dates",
		width: "200px",
		//   lablewith: '95px',
		widths: "215px"
	},
	{
		inputdata: "",
		title: "有效期至",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "dates",
		width: "200px",
		lablewith: '95px',
		widths: "215px"
	},
	{
		inputdata: "",
		title: "手机号",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "200px",
		lablewith: '90px'
	},
	{
		inputdata: "",
		title: "Email",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "205px",
		widths: "215px",
		lablewith: '80px'
	},
	{
		inputdata: "1.04",
		title: "加价系数",
		fontSize: "14px",
		color: "#333333",
		placeholder: "",
		types: "",
		inputtype: "numberPX",
		widths: "210px",
		width: "210px",
		min: 1,
		max: 5000,
	},
	{
		inputdata: "",
		title: "U8账套号",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "200px",
		widths: "215px",
		lablewith: '90px'
	},
	{
		inputdata: "",
		title: "简称",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "200px",
		widths: "215px",
		lablewith: '80px'
	},
]
export default fromdataedit;